module.exports = __webpack_public_path__ + "img/order-receiving.9312c84e.png";